var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_338_45044)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.42537 3.61328L1.56537 10.4733C1.31259 10.7265 1.15283 11.0578 1.11203 11.4133L0.8387 13.8133C0.820883 13.9821 0.838866 14.1527 0.891476 14.314C0.944087 14.4754 1.03014 14.6238 1.14402 14.7497C1.25789 14.8755 1.39703 14.9759 1.55235 15.0443C1.70766 15.1127 1.87566 15.1476 2.04537 15.1466H2.18537L4.58537 14.8733C4.93944 14.8323 5.26998 14.6753 5.52537 14.4266L12.3854 7.55995L8.42537 3.61328Z",
    fill: "#007DEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7061 3.0331L12.9661 1.2931C12.8206 1.14696 12.6476 1.03101 12.4571 0.951883C12.2666 0.872761 12.0624 0.832031 11.8561 0.832031C11.6499 0.832031 11.4457 0.872761 11.2552 0.951883C11.0647 1.03101 10.8917 1.14696 10.7461 1.2931L9.13281 2.90643L13.0928 6.86644L14.7061 5.2531C14.8523 5.10754 14.9682 4.93456 15.0474 4.74408C15.1265 4.55359 15.1672 4.34936 15.1672 4.1431C15.1672 3.93684 15.1265 3.73261 15.0474 3.54213C14.9682 3.35164 14.8523 3.17866 14.7061 3.0331Z",
    fill: "#007DEE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_338_45044"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/edit_pencil.e028e8672ecbc2416eccbe014bef720a.svg";
export { ForwardRef as ReactComponent };